import React from 'react';

import ProgramSlider from '@search/components/programslider';

const NoResults = ({ programs }) => (
  <div className="fv-search-app__no-results__container">
    <div className="fv-search-app__no-results">
      <h3>Sorry, no results were found</h3>
      <ul>
        <li>Check if your spelling is correct</li>
        <li>Try different keywords</li>
        <li>Try more general keywords</li>
      </ul>
    </div>

    <ProgramSlider
      programs={programs}
      type="program"
      title={'Or try some of these popular shows:'}
    />
  </div>
);

export default NoResults;
